import React from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { useTheme } from 'react-native-paper'

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    marginRight: 5,
    borderWidth: 3,
    borderRadius: 35,
    padding: 5,
    paddingHorizontal: 12,
    backgroundColor: '#132936',
  },
  iconText: {
    fontWeight: 'bold',
    textAlign: 'center',
  },
  shortIcon: {
    marginRight: -15,
  },
})

const CONFIG = {
  vegetarian: {
    color: 'vegetarian',
    long: 'Vege',
    short: 'V',
  },
  vegan: {
    color: 'vegan',
    long: 'Vegan',
    short: 'Ve',
  },
  glutenFree: {
    color: 'glutenFree',
    long: 'Gluten Free',
    short: 'Gf',
  },
  dairyFree: {
    color: 'dairyFree',
    long: 'Dairy Free',
    short: 'Df',
  },
  lowFodmap: {
    color: 'lowFodmap',
    long: 'Low Fodmap',
    short: 'Lf',
  },
  keto: {
    color: 'lowFodmap',
    long: 'Keto',
    short: 'K',
  },
  paleo: {
    color: 'lowFodmap',
    long: 'Paleo',
    short: 'P',
  },
}

const buildDetails = ({
  vegetarian,
  vegan,
  glutenFree,
  dairyFree,
  lowFodmap,
  diets,
  detailed,
}) => {
  let icons = []

  if (vegetarian) icons.push(configFor('vegetarian', detailed))
  if (vegan) icons.push(configFor('vegan', detailed))
  if (glutenFree) icons.push(configFor('glutenFree', detailed))
  if (dairyFree) icons.push(configFor('dairyFree', detailed))
  if (lowFodmap) icons.push(configFor('lowFodmap', detailed))
  if (diets.includes('KETOGENIC')) icons.push(configFor('keto', detailed))
  if (diets.includes('PALEOLITHIC')) icons.push(configFor('paleo', detailed))

  return icons
}

const configFor = (type, detailed) => {
  const { color, long, short } = CONFIG[type]
  const description = detailed ? long : short

  return { color, description }
}

const DietIcon = ({ color, description, style, fontSize }) => (
  <View {...{ color, style: [style, { borderColor: color }] }}>
    <Text style={[styles.iconText, { color, fontSize }]}>{description}</Text>
  </View>
)

const DietInformation = ({ recipe, detailed }) => {
  const { colors } = useTheme()

  const style = [styles.icon, detailed ? {} : styles.shortIcon]
  const fontSize = detailed ? 10 : 16

  return (
    <View style={styles.container}>
      {buildDetails({ ...recipe, detailed }).map(
        ({ color, description }, index) => (
          <DietIcon
            {...{
              key: `diet-${index}`,
              color: colors[color],
              description,
              style,
              fontSize,
            }}
          />
        ),
      )}
    </View>
  )
}

export default DietInformation
